import useCDNImage from './hooks/useCDNImage';

type CDNImageProps = {
  // The class name of the image
  className?: string;

  // The source of the image
  src: string;

  // The alternative text of the image
  alt?: string;

  // The width of the image
  imageWidth?: number;

  // The height of the image
  imageHeight?: number;

  // The allowed format of the image
  format?: 'jpg' | 'avif' | 'webp' | 'png' | '';

  // onclick event
  onClick?: () => void;

  // loading type
  loading?: 'eager' | 'lazy' | undefined;

  // aspect ratio
  aspectRatio?: string;

  fit?: string;

  // width on mobile
  mobileWidth?: number;

  // height on mobile
  mobileHeight?: number;
};

/**
 * @description  This component is a wrapper around the next/image component that uses the CDN to serve the images
 * @returns An image as a component that uses the CDN
 */

export const CDNImage = ({ className, src, alt, imageWidth, imageHeight, format, onClick, loading, aspectRatio, fit, mobileWidth, mobileHeight }: CDNImageProps) => {
  const { CDNImageUrl, mobileCDNImageUrl } = useCDNImage({ imageSrc: src, imageWidth, imageHeight, format, aspectRatio, fit, mobileWidth, mobileHeight });

  let width = imageWidth;
  let height = imageHeight;

  if (!src) return <></>;

  if (!mobileHeight && !mobileWidth) return <img className={className} width={width} height={height} src={CDNImageUrl} alt={alt} onClick={onClick} loading={loading} />;

  return (
    <picture>
      <source media='(max-width:640px)' srcSet={mobileCDNImageUrl} />
      <img className={className} width={width} height={height} src={CDNImageUrl} alt={alt} onClick={onClick} loading={loading} />
    </picture>
  );
};
